import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ModalPortal from '../ModalPortal';

const propTypes = {
  title: PropTypes.string,
  confirmCta: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

const defaultProps = {
  title: 'Confirm',
  confirmCta: 'Okay',
  onConfirm: () => {},
  onCancel: () => {},
};

class ModalConfirmation extends PureComponent {
  hide() {
    window.$(this.modal).modal('hide');
  }

  show() {
    window.$(this.modal).modal('show');
  }

  render() {
    const { confirmCta, title, children, onConfirm, onCancel } = this.props;

    return (
      <ModalPortal>
        <div
          className="ModalConfirmation modal"
          id="confirmationModal"
          ref={(c) => (this.modal = c)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content-wrapper">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">{children}</div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-danger"
                    onClick={onConfirm}
                  >
                    {confirmCta}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}

ModalConfirmation.propTypes = propTypes;
ModalConfirmation.defaultProps = defaultProps;

export default ModalConfirmation;
